import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Badge} from "@interstate/components/Badge";
import {useInterstateToken} from "@interstate/components/InterstateThemeProvider";
import {isClientEntityOperational} from "@common-core/coat-operational-hierarchy-appsync-model";
import {BadgeBar} from "../../../../../badges";
import {OperationalEntityPopover} from "../../../../hierarchy";
import {CreatePlanNodeLabelProps} from "../common";
import {reviewNodeBadgeMetadata} from "./reviewNodeBadgeMetadata";
import "../common/CreateTreeNodeLabel.scss";

export const ReviewPlanStepNodeLabel: FC<CreatePlanNodeLabelProps> = ({
  node
}) => {
  const {t} = useTranslation();
  const token = useInterstateToken();
  const {labelKey, variant, startIcon, endIcon} = reviewNodeBadgeMetadata(
    token,
    node
  );
  const operational = isClientEntityOperational(node.source);

  const badge = (
    <div>
      <Badge
        id={`create-plan-node-badge-${node.caId}`}
        data-testid={`create-plan-node-badge-${node.caId}`}
        className={"create-plan-node-badge"}
        variant={variant}
        startIcon={startIcon}
        endIcon={endIcon}>
        <span className={"create-plan-node-badge-label"}>{t(labelKey!)}</span>
      </Badge>
    </div>
  );

  return (
    <div
      id={`create-plan-node-label-${node.caId}`}
      data-testid={`create-plan-node-label-${node.caId}`}
      className={"create-tree-node-label create-plan-node-label"}>
      <div className={"cust-name"}>
        <span>{node.source.custName}</span>
      </div>
      <BadgeBar>
        {operational ? (
          <OperationalEntityPopover
            caId={node.caId}
            operationalEntities={node.source.mappedOperationalEntities || []}>
            {badge}
          </OperationalEntityPopover>
        ) : (
          badge
        )}
      </BadgeBar>
    </div>
  );
};
